import React from 'react';
import { motion } from 'framer-motion';
import './PrizesSection.css';

const PrizesV2Section = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const cardVariants = {
    hidden: { y: 50, opacity: 0, scale: 0.9 },
    visible: {
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  return (
    <div className="prizes-v2-content">
      <motion.div className="prizes-announcement" variants={cardVariants}>
        <div className="announcement-card">
          <div className="announcement-icon">🎉</div>
          <div className="announcement-content">
            <h3>الجوائز الكاملة مُعلنة!</h3>
            <p>اكتشف الآن جميع الجوائز المتاحة للفائزين في المسابقة</p>
          </div>
        </div>
      </motion.div>
      
      {/* Podium Section */}
      <motion.div className="podium-container" variants={cardVariants}>
        <div className="podium-grid">
          {/* Second Place */}
          <div className="podium-card place-2">
            <div className="prize-icon-container">
              <div className="prize-icon-bg"></div>
              <div className="prize-icon">🥈</div>
            </div>
            <div className="prize-content">
              <div className="prize-title">المركز الثاني</div>
              <div className="prize-subtitle">Second Place</div>
              <div className="prize-amount">5,000 ₪</div>
              <div className="prize-description">
                حل تقني متطور ومبتكر يحل مشكلة حقيقية في المجتمع مع تطبيق عملي قابل للتنفيذ
              </div>
            </div>
            <div className="prize-glow"></div>
          </div>

          {/* First Place */}
          <div className="podium-card place-1">
            <div className="prize-icon-container">
              <div className="prize-icon-bg"></div>
              <div className="prize-icon">🥇</div>
            </div>
            <div className="prize-content">
              <div className="prize-title">المركز الأول</div>
              <div className="prize-subtitle">First Place</div>
              <div className="prize-amount">7,500 ₪</div>
              <div className="prize-description">
                الحل الأكثر ابتكاراً وتأثيراً لمشكلة حقيقية في الحياة اليومية مع إمكانية التوسع والتطوير المستقبلي
              </div>
            </div>
            <div className="prize-glow"></div>
          </div>

          {/* Third Place */}
          <div className="podium-card place-3">
            <div className="prize-icon-container">
              <div className="prize-icon-bg"></div>
              <div className="prize-icon">🥉</div>
            </div>
            <div className="prize-content">
              <div className="prize-title">المركز الثالث</div>
              <div className="prize-subtitle">Third Place</div>
              <div className="prize-amount">3,000 ₪</div>
              <div className="prize-description">
                فكرة مبدعة وحل تقني جيد يقدم قيمة مضافة واضحة ويحسن من تجربة المستخدم
              </div>
            </div>
            <div className="prize-glow"></div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default PrizesV2Section;
